module.exports = __webpack_public_path__ + "static/media/product-1.d63d9eff.png";